import { render } from "./TheLogistikPicken.vue?vue&type=template&id=1cac5857&scoped=true"
import script from "./TheLogistikPicken.vue?vue&type=script&lang=js"
export * from "./TheLogistikPicken.vue?vue&type=script&lang=js"

import "./TheLogistikPicken.vue?vue&type=style&index=0&id=1cac5857&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cac5857"]])

export default __exports__